'use client';

import { useState, useEffect } from 'react';

// ----------------------------------------------------------------------

/** 한 글자 치는 간격(ms) */
const TYPE_STEP_MS = 140;
/** 다 친 뒤 커서가 깜박이는 시간(ms) — 이 뒤에 「끝났다」가 된다 */
const CARET_HOLD_MS = 900;

/**
 * 검색칸에 글자가 **한 글자씩 쳐지는** 연출 — 한 번만 돈다.
 *
 * 🔑 `start` 가 처음 참이 될 때 시작한다(장면이 화면에 들어올 때). 그 전에는 빈 칸이다 — 글자 칸이 비어 있을 뿐 장면의 내용은 처음부터 보인다.
 * ⚠️ 움직임을 줄이라는 설정(`reduceMotion`)이면 치지 않고 처음부터 다 쳐진 상태다.
 * @returns `typed` 지금까지 쳐진 글자 · `done` 다 치고 커서까지 깜박인 뒤인가
 */
export function useHomeTyping(text: string, start: boolean, reduceMotion: boolean) {
  const [count, setCount] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (reduceMotion || !start || count >= text.length) return undefined;
    const timer = window.setTimeout(() => setCount((prev) => prev + 1), TYPE_STEP_MS);
    return () => window.clearTimeout(timer);
  }, [reduceMotion, start, count, text.length]);

  useEffect(() => {
    if (reduceMotion || done || count < text.length) return undefined;
    const timer = window.setTimeout(() => setDone(true), CARET_HOLD_MS);
    return () => window.clearTimeout(timer);
  }, [reduceMotion, done, count, text.length]);

  if (reduceMotion) return { typed: text, done: true };
  return { typed: text.slice(0, count), done };
}
